export default __webpack_public_path__ + "static/media/AG16.9088c685.mp3";